<template>
  <div>
    <form @submit.prevent="handlePayment">
      <div id="payment-element" ref="paymentElement"></div>
      <div v-if="loadingFormMessage" class="text-center pt-2 pb-2">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      </div>
      <div id="payment-errors" class="text-danger pb-2">{{ $t(error) }}</div>
      <div class="modal-footer">
        <button v-if="error" class="btn btn-default text-white bg-danger border-0" @click="closeCheckout()">{{ $t("Cancel") }}</button>
        <button v-if="isFormReady" type="submit" class="btn btn-default text-white bg-gradient-green border-0">
          {{ $t(loading ? 'Processing...' : 'Pay Now') }}
        </button><!--v-if-->
      </div>
    </form>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"

export default {
  name: "CheckoutPage",
  emits: ["fetch", "closeModal", "gotPaymentIntent"],
  data() {
    return {
      loadingFormMessage: true,
      isFormReady: false,
      paymentIntent: {},
      stripe: null,
      elements: null,
      card: null,
      loading: false,
      error: ""
    }
  },
  async mounted() {
    const payload = {
      employeeId: this.$store.state.user.claims.user_id,
      id: this.$route.params.id,
    }
    try {
      this.paymentIntent = await FirebaseFunctionsHelper.callFunction("request-buy", payload)
      this.$emit("gotPaymentIntent", this.paymentIntent)
    } catch (err) {
      this.error = err.message
      console.log("catch error", err)
      this.loadingFormMessage = false
      return
    }

   this.loadingFormMessage = false

    this.stripe = await loadStripe(this.paymentIntent.publishableKey, {
      stripeAccount: this.paymentIntent.connectedAccountId,
    })

    this.elements = this.stripe.elements({
      clientSecret: this.paymentIntent.clientSecretKey,
    })

    // Create the Payment Element with the clientSecret
    if (this.paymentIntent.clientSecretKey) {
      this.paymentElement = this.elements.create("payment")
      this.paymentElement.mount(this.$refs.paymentElement)
      console.log("3", this.isFormReady)
      // Handle real-time validation errors
      this.paymentElement.on("change", (event) => {
        this.error = event.error ? event.error.message : ""
      })
      console.log("4", this.isFormReady)
      this.paymentElement.on("ready", () => {
        console.log("loadddedededededededede")
        this.isFormReady = true
      })
      console.log("5", this.isFormReady)
    }
  },
  beforeUnmount() {
    // Clean up the card element when the component is destroyed
    if (this.card) {
      this.card.destroy()
    }
  },
  methods: {
    closeCheckout() {
      this.$emit("closeModal", false)
    },
    async handlePayment() {
      this.loading = true
      this.error = ""
      let successPayment = false
      try {

        // Confirm the payment with the payment method from Payment Elements
        const { error: paymentError, paymentIntent } = await this.stripe.confirmPayment({
          elements: this.elements,
          // confirmParams: {
          //   return_url: window.location.href, // Replace with your success URL
          // }
          redirect: "if_required"
        })

        if (paymentError) {
          // this.$swal.fire({
          //   icon: "error",
          //   html: paymentError.message,
          //   title: "Something went wrong!",
          // })
          console.log("paymentError", paymentError)
          throw new Error(paymentError.message)
        }
        successPayment = true
      } catch (err) {
        this.error = err.message
        console.log("catch error", err)
      } finally {
        console.log("finallyyyy")
        this.loading = false
        if (this.error === "" && successPayment) {
          this.$emit("closeModal", true)
        }
      }
    }
  }
}
</script>

<style>
#card-element {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
}
</style>
